import { Tier } from '@backrs_ui/common-ui';

import { SCHOOL_LEVEL } from '@backrs_ui/grow-ui/src/models/models';

import { Page, View } from '@react-pdf/renderer';

import { resultPageStyles } from './resultPDF.styles';
import { MarkersOfSuccessPDF } from '../molecules/MarkersOfSuccessPDF';

type PageFourProps = Readonly<{
  tier: Tier;
}>;

export function ResultPageFour({ tier }: PageFourProps) {
  return (
    <Page size="LETTER" style={resultPageStyles.pageFont}>
      <View style={resultPageStyles.markersOfSuccessContainer}>
        <MarkersOfSuccessPDF schoolLevel={SCHOOL_LEVEL.COLLEGE} tier={tier} page={2} />
      </View>
    </Page>
  );
}
